<app-dashboard-container
	class="dashboard-aanwezigheid-statistieken"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilters(), $event)"
	[customExportItems]="customExportItems()"
>
	<app-filter-panel
		[defaultFilters]="defaultFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/aanwezigheid"
		[permanentFilterExpressions]="permanentFilters()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-legenda class="right" [attribute]="['aw_fun_nm_interventielaag']" [keyIsClassName]="true"></app-legenda>
		<div class="container">
			<div class="row">
				<app-aanwezigheidspiramide
					[requestContext]="requestContext()"
					[attr.data-exportable]="exportCumulatieveAanwezigheid() ? 'true' : null"
				></app-aanwezigheidspiramide>
				<app-aanwezigheidspiramide-per-maand
					[requestContext]="requestContext()"
					[attr.data-exportable]="exportAanwezigheidPerMaand() ? 'true' : null"
				></app-aanwezigheidspiramide-per-maand>
			</div>
			<app-overzicht-interventielagen
				[requestContext]="requestContext()"
				(totalChanged)="onTotalChanged($event)"
				[exportMode]="exportMode()"
			></app-overzicht-interventielagen>
		</div>
	</section>
</app-dashboard-container>
